import {
  Button,
  Dialog,
  TextField,
  LinearProgress,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from "@material-ui/core";
import React, { useRef, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import cert from "../mem_cert.jpg";
import welen from "../letter_en.jpg";
import stwelen from "../student_wel_en.jpg";
import stwelhi from "../student_wel_hi.jpg";
import welhi from "../letter_hi.jpg";
import idcard from "../Member_ID_Card.jpg"; //Imported by Jyoti for ID Card on 29th Oct., 2021
import studentId from "../Student_Member_ID_Card.jpg";
import studentCert from "../Student_cert.jpg";
import "../styles/AdminApplicationsView.css";
import { myBucket } from "../services/UploadService";
import { ApiURL } from "../constants/ApiUrl";
import { findLastKey } from "lodash";
// import {useSelector, useDispatch} from 'react-redux'; // 21 oct

function AdminApplicationsView() {
  const [TempCour, setTempCour] = useState("");
  const [Progress1, setProgress1] = useState(0);
  const [Progress2, setProgress2] = useState(0);
  // const [error, setError] = useState("")
  const [error, setError] = useState(false);
  const [sign, setsign] = useState(false);
  const [sign1, setsign1] = useState(false);
  const [nameE, setnameE] = useState("");
  const [phoneE, setphoneE] = useState("");
  const [profileE, setProfileE] = useState("");
  const [signatureE, setsignatureE] = useState("");
  const [secEmailError, setsecEmailError] = useState("");
  const [RefMemN, setRefMemN] = useState("");
  const [secphoneE, setsecphoneE] = useState("");
  const [RefnameE, setRefnameE] = useState("");
  const [medError, setmedError] = useState("");
  const [RegE, setRegE] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isTrue, setIsTrue] = useState(true);
  const [Editable, setEditable] = useState(false);
  const FData = useSelector((state) => state.FormDataReducer);
  const [TempDetails, setTempDetails] = useState({});
  const [TempCList, setTempCList] = useState([]);
  const [nmoLists, setNmoLists] = useState([]);
  const [nmoPrant, setNmoPrant] = useState([]);
  const [Tp, setTp] = useState(0);
  const [Tp1, setTp1] = useState(10);
  const [uploadsComplete, setUploadsComplete] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isApproving, setIsApproving] = useState(false);

  const LoginReducer = useSelector((state) => state.LoginReducer);
  var loginRes;
  if (LoginReducer.user !== undefined) {
    loginRes = LoginReducer.user.role;
    // console.log(loginRes, "rolll")
  }
  // console.log(loginRes,"unn")

  const FormDetails = useSelector((state) => state.AdminReducer.selectedApp);
  // const FormDetails = useSelector((state) => {...state.AdminReducer.selectedApp, });

  // console.log(FormDetails.address.line1,"1 line")
  // var resi1= `${FormDetails.address.line1} , ${FormDetails.address.line2}`
  // var resi2= `${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`

  // console.log(FormDetails,"deee")
  // alert(FormDetails.address,"1 line")
  // var resi1 = `${FormDetails.address.line1} , ${FormDetails.address.line2}`
  // var resi2 = `${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`

  const canvas = useRef();
  const canvas4 = useRef();
  const canvas5 = useRef();

  const canvas3 = useRef();
  const image3 = useRef();
  const image4 = useRef();
  const image5 = useRef();

  const canvas0 = useRef();
  const image0 = useRef();

  const canvas7 = useRef();
  const image7 = useRef();

  // const image4 = useRef();

  const image = useRef();
  const canvas1 = useRef();
  const image1 = useRef();
  const canvas2 = useRef();
  const image2 = useRef();
  const [Open, setOpen] = useState(false);

  const [Open1, setOpen1] = useState(false);
  const [Open2, setOpen2] = useState(false);

  const [TempImg, setTempImg] = useState("");
  const [TempImg2, setTempImg2] = useState("");

  // console.log(TempImg,"imageeee")
  const [TempName, setTempName] = useState("");
  const [TempQul, setTempQul] = useState("");

  const [TempReason, setTempReason] = useState("");
  // const [FileTemp, setFileTemp] = useState({"wel_en": '', "wel_hi": '', "mem_cert_image": ''})
  const [TempCert, setTempCert] = useState("");
  const [TempCerts, setTempCerts] = useState("");

  const [TempWelEn, setTempWelEn] = useState("");
  const [TempWelHi, setTempWelHi] = useState("");
  const [TempStWelHi, setTempStWelHi] = useState("");
  const [TempStwelEn, setTempStwelEn] = useState("");
  const [TempIdCard, setTempIdCard] = useState(""); //Created by Jyoti for ID Card on 29th Oct., 2021
  const [TempIdCards, setTempIdCards] = useState(""); //Created by Jyoti for ID Card on 29th Oct., 2021

  const [MemNo, setMemNo] = useState(0);
  const memNoRef = useRef("");
  const [UploadCount, setUploadCount] = useState(0);
  const [IsOpen1, setIsOpen1] = useState(false);
  const [IsOpen2, setIsOpen2] = useState(false);
  const [IsOpen3, setIsOpen3] = useState(false);
  const [IsOpen4, setIsOpen4] = useState(false);
  const [IsOpen5, setIsOpen5] = useState(false);
  const [IsOpen6, setIsOpen6] = useState(false);
  const [IsOpen7, setIsOpen7] = useState(false);

  const [stateList, setStateList] = useState([]);
  const [SName, setSName] = useState("");
  const [CName, setCName] = useState("");
  const [collagelist, setCollagelist] = useState([]);
  // const [memno,setMemno]=useState()
  const [isSubmitting, setisSubmitting] = useState(false);
  const [Type, setType] = useState("");
  // console.log(!FormDetails.isVerified)

  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [isLoadingApplication, setIsLoadingApplication] = useState(
    !FormDetails._id || (id && FormDetails._id !== id)
  );

  useEffect(() => {
    const loadApplication = async () => {
      if (!id) {
        history.replace("/admin/applications");
        return;
      }
      if (FormDetails._id === id) {
        setIsLoadingApplication(false);
        return;
      }
      try {
        const result = await axios.get(`${ApiURL}/api/get_applications/${id}`);
        dispatch({ type: "SELECTED_APPLICATION", payload: result.data.data });
      } catch (error) {
        console.error(error);
        history.replace("/admin/applications");
      } finally {
        setIsLoadingApplication(false);
      }
    };
    loadApplication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // console.log(FormDetails.payment.success, FormDetails)

  useEffect(() => {
    if (!FormDetails._id) return;
    a();
    verifiedApp();
    // react-hooksexhaustive-deps()
  }, [FormDetails._id]);

  useEffect(() => {
    // console.log(UploadCount, TempCert, TempWelEn, TempWelHi);
    // eslint-disable-next-line
  }, [
    UploadCount,
    TempCert,
    TempCerts,
    TempIdCard,
    TempIdCards,
    TempWelEn,
    TempWelHi,
    TempStwelEn,
    TempStWelHi,
  ]);

  var s = [];
  const a = async () => {
    const result = await axios.get(`${ApiURL}/api/get_states`);
    result.data.forEach((element) => {
      s.push(element.state_name);
    });
    setStateList(s);
  };

  const collegeChanged = (e) => {
    // console.log(e, 'value of input')
    if (e == "other") {
      setIsTrue(false);
    }
    setTempDetails({ ...TempDetails, ["college"]: e });
    setCName(e);
  };

  const getCollage = async (state) => {
    const result = await axios.post(`${ApiURL}/api/get_medical_college`, {
      // addinng API for getting prant
      state: state,
    });
    const college_list = result.data;
    college_list.forEach((element) => {
      s.push(element);
    });

    console.log("Result set in state", s);
    setCollagelist(s);
  };
  const stateChanged = async (e) => {
    setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });
    setSName(e.target.value);
    getCollage(e.target.value);
  };
  async function getMemNo() {
    const r = await axios.post(`${ApiURL}/constants/get_membershipno`, {
      applicationId: FormDetails._id,
      apptype: FormDetails.appType,
      nmoState: FormDetails.nmo_state,
    });
    memNoRef.current = r.data.count;
    setMemNo(r.data.count);
    return r.data.count;
  }

  async function releaseMemNo() {
    if (!FormDetails._id || FormDetails.appApproved) return;
    try {
      await axios.post(`${ApiURL}/constants/release_membershipno`, {
        applicationId: FormDetails._id,
      });
    } catch (err) {
      console.error(err);
    }
    memNoRef.current = "";
    setMemNo(0);
    setUploadsComplete(false);
  }

  function activeMembershipNo() {
    return memNoRef.current || MemNo;
  }

  async function verifiedApp() {
    // console.log('::::::')
  }

  const handleClose = () => {
    setOpen(false);
    setOpen1(false);
  };

  const handleTempName = (e) => {
    setTempName(e.target.value);
  };
  const handleTempQul = (e) => {
    setTempQul(e.target.value);
  };
  const handleTempCour = (e) => {
    setTempCour(e.target.value);
  };
  const handleTempReason = (e) => {
    setTempReason(e.target.value);
  };

  const handleApprove = async () => {
    let mem;
    try {
      mem = String(await getMemNo());
    } catch (err) {
      alert(
        err.response?.data?.msg ||
          "Could not reserve a membership number. Please try again."
      );
      return;
    }
    generateWelCertEn(mem, FormDetails.name);
    generateWelCertHi(mem, FormDetails.name);
    var resi1 = `${FormDetails.address.line1} , ${FormDetails.address.line2}`;
    var resi2 = `${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`;

    generateCert(
      mem,
      FormDetails.name,
      FormDetails.qualifications,
      FormDetails.college,
      FormDetails.nmo_unit,
      FormDetails.email,
      FormDetails.blood_group,
      resi1,
      resi2,
      FormDetails.phone,
      FormDetails.profile_image,
      FormDetails.signature_image,
      false
    );

    setTempName(FormDetails.name);
    setTempQul(FormDetails.qualifications);

    setTempCour(FormDetails.college);
    setOpen(true);
  };

  const handleReject = () => {
    setOpen1(true);
  };
  const handlever = () => {
    setOpen2(true);
  };

  const isR2Url = (url) => typeof url === "string" && url.startsWith("https://");

  const validateApprovalDocuments = () => {
    if (FormDetails.appType !== "student") {
      return (
        isR2Url(TempCert) &&
        isR2Url(TempWelEn) &&
        isR2Url(TempWelHi) &&
        isR2Url(TempIdCard)
      );
    }
    return (
      isR2Url(TempCerts) && isR2Url(TempStwelEn) && isR2Url(TempIdCards)
    );
  };

  const handleFinalApproval = async () => {
    const approvalMemNo = activeMembershipNo();
    if (!approvalMemNo) {
      alert("Membership number is missing. Click Approve again.");
      return;
    }
    if (!validateApprovalDocuments()) {
      alert(
        "All documents must be uploaded before approval. Please wait for uploads to finish and try again."
      );
      return;
    }

    setIsApproving(true);
    const isStudent = FormDetails.appType === "student";
    const certImage = isStudent ? TempCerts : TempCert;
    const welEn = isStudent ? TempStwelEn : TempWelEn;
    const welHi = isStudent ? "" : TempWelHi;
    const idCard = isStudent ? TempIdCards : TempIdCard;

    try {
      const result1 = await axios.post(
        `${ApiURL}/api/approve_app/${FormDetails._id}`,
        {
          mem_cert_image: certImage,
          wel_en: welEn,
          wel_hi: welHi,
          mem_no: approvalMemNo,
          education_year: FormDetails.education_year,
          Apptype: FormDetails.appType,
          idcard: idCard,
        },
        { timeout: 120000 }
      );

      if (result1.data.status == 409) {
        memNoRef.current = "";
        setMemNo(0);
        setUploadsComplete(false);
        setIsOpen1(false);
        setOpen(false);
        alert(result1.data.msg || "Approval failed. Please try again.");
        return;
      }

      if (result1.data.status == 200) {
        setIsOpen1(false);

        axios.post(`${ApiURL}/app_send_mail`, {
          to_email: FormDetails.state_sec_email,
          applicant_name: FormDetails.name,
          state: FormDetails.address.state,
          mem_id: approvalMemNo.toString(),
          idCard: idCard,
        });

        axios.post(`${ApiURL}/send_mail`, {
          to_email: FormDetails.email,
          cc_email: [FormDetails.state_sec_email],
          certificate_Img: certImage,
          welcomeLatter: welEn,
          welcomeLattertwo: welHi,
          mem_no: approvalMemNo.toString(),
          idcard: idCard,
        });

        if (isStudent) {
          setTempStWelHi("");
          setTempStwelEn("");
        } else {
          setTempWelEn("");
          setTempWelHi("");
        }
        alert("Application Approved");
        history.replace("/admin/applications");
      } else {
        alert(result1.data.msg || "Approval failed. Please try again.");
      }
    } catch (err) {
      const msg =
        err.response?.data?.msg ||
        err.response?.data?.error ||
        (err.code === "ECONNABORTED"
          ? "Request timed out. The server may still be processing — check the applications list before retrying."
          : err.message);
      if (err.response?.status === 409) {
        memNoRef.current = "";
        setMemNo(0);
        setUploadsComplete(false);
        setIsOpen1(false);
        setOpen(false);
      }
      alert(`Approval failed: ${msg}`);
    } finally {
      setIsApproving(false);
    }
  };
  const handleFinalReject = () => {
    setIsOpen2(true);
  };

  const handleSubApp = async () => {
    const uploadMemNo = activeMembershipNo();
    if (!uploadMemNo) {
      alert("Membership number is missing. Click Approve again.");
      return;
    }
    setIsUploading(true);
    setUploadsComplete(false);
    setisSubmitting(true);

    const resi1 = `${FormDetails.address.line1} , ${FormDetails.address.line2}`;
    const resi2 = `${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`;

    try {
      if (FormDetails.appType !== "student") {
        generateCert(
          uploadMemNo.toString(),
          TempName,
          TempQul,
          FormDetails.college,
          FormDetails.nmo_unit,
          FormDetails.email,
          FormDetails.blood_group,
          resi1,
          resi2,
          FormDetails.phone,
          FormDetails.profile_image,
          FormDetails.signature_image,
          true
        );
        await Promise.all([
          uploadFile(
            `member_IdCard_${FormDetails._id}.jpeg`,
            canvas3,
            setTempIdCard
          ),
          uploadFile(`member_cert_${FormDetails._id}.jpg`, canvas, setTempCert),
          uploadFile(`wel_en_${FormDetails._id}.jpg`, canvas1, setTempWelEn),
          uploadFile(`wel_hi_${FormDetails._id}.jpg`, canvas2, setTempWelHi),
        ]);
      } else {
        generateCert(
          uploadMemNo.toString(),
          TempName,
          TempQul,
          TempCour,
          FormDetails.nmo_unit,
          FormDetails.email,
          FormDetails.blood_group,
          resi1,
          resi2,
          FormDetails.phone,
          FormDetails.profile_image,
          FormDetails.signature_image,
          true
        );
        await Promise.all([
          uploadFile(
            `member_IdCard_${FormDetails._id}.jpeg`,
            canvas5,
            setTempIdCards
          ),
          uploadFile(
            `member_cert_${FormDetails._id}.jpg`,
            canvas4,
            setTempCerts
          ),
          uploadFile(`wel_en_${FormDetails._id}.jpg`, canvas0, setTempStwelEn),
          uploadFile(`wel_hi_${FormDetails._id}.jpg`, canvas7, setTempStWelHi),
        ]);
      }
      setUploadsComplete(true);
    } catch (err) {
      console.error("Document upload failed:", err);
      alert("Document upload failed. Please try again.");
      setUploadsComplete(false);
    } finally {
      setIsUploading(false);
      setisSubmitting(false);
    }
  };

  const handleRejApp = async () => {
    if (!FormDetails.appApproved) {
      await releaseMemNo();
    }
    await axios.post(`${ApiURL}/rej_send_mail`, {
      to_email: FormDetails.email,
      reason: TempReason,
    });
    setIsOpen2(false);
    history.replace("/admin/applications");
  };

  const handleNoApp = async () => {
    const cancellingApproval = IsOpen1;
    setOpen2(false); // 20 oct jyoti add this function for reject
    setIsOpen1(false);
    setIsOpen2(false);
    setIsOpen3(false);
    setIsOpen5(false);
    setIsOpen6(false);
    setIsOpen7(false);
    setIsApproving(false);
    setisSubmitting(false);
    if (cancellingApproval && !FormDetails.appApproved) {
      setOpen(false);
      await releaseMemNo();
    }
  };

  const handleConfirmPayment = async () => {
    const response = await axios.post(`${ApiURL}/payment/cnf_payment`, {
      orderId: FormDetails.payment.transactionId,
    });
    if (response.data.msg === "success") {
      axios
        .post(`${ApiURL}/cnf_send_mail`, {
          to_email: FormDetails.email,
        })
        .then((res) => {
          alert(res.data);
        })
        .catch((err) => {
          console.log(err, "jfgd");
        });

      dispatch({ type: "CONFIRM_PAYMENT" });
      setIsOpen3(false);
      // alert("Payment Status updated.")
    } else {
      setIsOpen3(false);
      alert(response.data.msg);
    }
  };

  const handleDelete = async () => {
    // alert("as")

    if (!FormDetails.appApproved) {
      await releaseMemNo();
    }
    const response = await axios.post(`${ApiURL}/api/delete`, {
      orderId: FormDetails._id,
    });
    if (response.data.msg === "success") {
      dispatch({ type: "deleted" });
      setIsOpen5(false);
      alert("This application has been deleted sucessfully.");
      history.replace("/admin/applications");
    } else {
      setIsOpen5(false);
      alert(response.data.msg);
    }
    // alert(FormDetails.email)
    // alert("deleted");
    // setIsOpen5(false);
  };

  // disabling db data
  const handleFeeRefunded = async () => {
    // alert("as")

    try {
      if (!FormDetails.appApproved) {
        await releaseMemNo();
      }
      const response = await axios.post(`${ApiURL}/api/refund`, {
        orderId: FormDetails._id,
      });
      if (response.data.msg === "success") {
        dispatch({ type: "deleted" });
        setIsOpen7(false);
        alert("This application has been deleted sucessfully.");
        alert("An email has been sent regarding the application deletion.");
        const res = await axios.post(`${ApiURL}/refund/send_mail`, {
          to_email: FormDetails.email,
        });

        history.replace("/admin/applications");
      } else {
        setIsOpen7(false);
        alert(response.data.msg);
      }
    } catch (e) {
      console.log("Error: ", e);
    } finally {
      setIsOpen7(false);
    }
  };
  const handleVarified = async () => {
    const result = await axios.post(
      `${ApiURL}/api/verify_app/${FormDetails._id}`
    );
    if (result.data.msg === "Application Verified") {
      dispatch({ type: "VERIFIED" });
      setIsOpen6(false);
      alert("This application has been verified sucessfully.");
      // history.replace("/admin/applications");
    } else {
      setIsOpen6(false);
      alert(result.data.msg);
    }
  };

  function uploadFile(name, canv, setVal) {
    return new Promise((resolve, reject) => {
      canv.current.toBlob(
        async function (blob) {
          if (!blob) {
            reject(new Error(`Failed to generate image: ${name}`));
            return;
          }

          try {
            const key = `applications/${FormDetails.appId}/${name}`;

            const res = await axios.get(
              `${ApiURL}/api/upload/signed-url?key=${encodeURIComponent(
                key
              )}&contentType=${encodeURIComponent("image/jpeg")}`
            );
            const { url } = res.data;

            await new Promise((resolveXhr, rejectXhr) => {
              const xhr = new XMLHttpRequest();
              xhr.open("PUT", url);
              xhr.setRequestHeader("Content-Type", "image/jpeg");
              xhr.setRequestHeader("Cache-Control", "no-cache");

              xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                  setProgress1(Math.round((event.loaded / event.total) * 100));
                }
              };

              xhr.onload = () => {
                if (xhr.status === 200) resolveXhr();
                else
                  rejectXhr(
                    new Error(`Upload failed with status ${xhr.status}`)
                  );
              };
              xhr.onerror = () =>
                rejectXhr(new Error("Network error during upload"));

              xhr.send(blob);
            });

            const publicUrl = `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${key}`;
            setUploadCount((count) => count + 1);
            setVal(publicUrl);
            setProgress1(0);
            resolve(publicUrl);
          } catch (err) {
            console.error("Upload error (canvas file):", err);
            reject(err);
          }
        },
        "image/jpeg"
      );
    });
  }


  function generateWelCertHi(mem_no, doc_name) {
    if (FormDetails.appType !== "student") {
      const can = canvas2;
      const ctx = can.current.getContext("2d");
      const img = image2.current;
      ctx.drawImage(img, 0, 0);
      // console.log(FileTemp);
      const dd = new Date();
      ctx.font = "25px serif";
      ctx.fillText(mem_no, 835, 676);
      ctx.fillText(
        dd.getDate() + "/" + (dd.getMonth() + 1) + "/" + dd.getFullYear(),
        950,
        580
      );
      ctx.fillText(doc_name, 180, 620);
    } else {
      const can = canvas7;
      const ctx = can.current.getContext("2d");
      const img = image7.current;
      ctx.drawImage(img, 0, 0);
      // console.log(FileTemp);
      const dd = new Date();
      ctx.font = "50px serif";
      ctx.fillText(mem_no, 1520, 1330);
      ctx.fillText(
        dd.getDate() + "/" + (dd.getMonth() + 1) + "/" + dd.getFullYear(),
        2130,
        1140
      );
      ctx.fillText(doc_name, 320, 1210);
    }
    // can.current.toBlob(function(blob){
    //     setTempWelEn(blob);
    // }, "image/jpeg")
  }
  function generateWelCertEn(mem_no, doc_name) {
    if (FormDetails.appType !== "student") {
      const can = canvas1;
      const ctx = can.current.getContext("2d");
      const img = image1.current;
      ctx.drawImage(img, 0, 0);
      // console.log(FileTemp);
      const dd = new Date();
      ctx.font = "25px serif";
      ctx.fillText(mem_no, 950, 720);
      ctx.fillText(
        dd.getDate() + "/" + (dd.getMonth() + 1) + "/" + dd.getFullYear(),
        950,
        580
      );
      ctx.fillText(doc_name, 235, 640);
    } else {
      const can = canvas0;
      const ctx = can.current.getContext("2d");
      const img = image0.current;
      ctx.drawImage(img, 0, 0);
      // console.log(FileTemp);
      const dd = new Date();
      ctx.font = "25px serif";
      ctx.fillText(mem_no, 900, 700);
      ctx.fillText(
        dd.getDate() + "/" + (dd.getMonth() + 1) + "/" + dd.getFullYear(),
        950,
        580
      );
      ctx.fillText(doc_name, 240, 630);
    }
  }

  function generateCert(
    mem_no,
    doc_name,
    qualification,
    college,
    nmo_unit,
    email,
    blood_group,
    address1,
    address2,
    mobile_no
  ) {
    if (FormDetails.appType !== "student") {
      var can = canvas;
      const ctx = can.current.getContext("2d");
      const img = image.current;
      ctx.drawImage(img, 0, 0);
      ctx.font = "40px serif";
      ctx.fillText(mem_no, 650, 227);
      const dd = new Date();
      ctx.fillText(
        dd.getDate() + "/" + (dd.getMonth() + 1) + "/" + dd.getFullYear(),
        1050,
        230
      );
      ctx.font = "40px serif";
      ctx.fillStyle = "#2D308F";
      ctx.fillText(doc_name, 800, 440);
      setTempImg(can.current.toDataURL("image/jpeg"));
      const can_id = canvas3;
      const ctx_id = can_id.current.getContext("2d");
      const img_id = image3.current;
      ctx_id.drawImage(img_id, 0, 0);
      ctx_id.font = "30px serif";
      ctx_id.fillStyle = "#2D308F";
      ctx_id.fillText(mem_no, 390, 195);
      ctx_id.font = "23px serif";
      ctx_id.fillStyle = "#2D308F";
      ctx_id.fillText(doc_name, 345, 250);
      ctx_id.font = "23px serif";
      ctx_id.fillText(qualification, 345, 300);
      ctx_id.font = "25px serif";
      ctx_id.fillText(nmo_unit, 345, 355);
      const date = new Date();
      ctx_id.fillText(date.getFullYear(), 335, 435);
      ctx_id.font = "25px serif";
      ctx_id.fillText(FormDetails.phone, 200, 540);
      ctx_id.fillText(FormDetails.email, 200, 575);
      ctx_id.fillText(FormDetails.blood_group, 210, 610);
      ctx_id.font = "25px serif";
      ctx_id.fillText(FormDetails.address.line1, 200, 645);
      const state = `${FormDetails.address.city} ${","}${
        FormDetails.address.state
      } ${","}${FormDetails.address.pincode}`;
      ctx_id.fillText(state, 200, 675);
      setTempIdCard(can_id.current.toDataURL("image/jpeg"));
    } else {
      var can = canvas4;
      const ctx = can.current.getContext("2d");
      const img = image4.current;
      ctx.drawImage(img, 0, 0);
      ctx.font = "40px serif";
      ctx.fillStyle = "#2D308F";
      ctx.fillText(mem_no, 650, 230);
      const dd = new Date();
      ctx.fillText(
        dd.getDate() + "/" + (dd.getMonth() + 1) + "/" + dd.getFullYear(),
        1050,
        230
      );
      ctx.font = "40px serif";
      ctx.fillText(doc_name, 800, 400);
      setTempImg2(can.current.toDataURL("image/jpeg"));
      const can_id = canvas5;
      const ctx_id = can_id.current.getContext("2d");
      const img_id = image5.current;
      ctx_id.drawImage(img_id, 0, 0);
      ctx_id.font = "25px serif";
      ctx_id.fillStyle = "#2D308F";
      ctx_id.fillText(mem_no, 335, 190);
      ctx_id.font = "23px serif";
      ctx_id.fillText(doc_name, 335, 245);
      ctx_id.font = "23px serif";
      ctx_id.fillText(qualification, 335, 282);
      ctx_id.fillText(college, 335, 317);
      ctx_id.font = "25px serif";
      ctx_id.fillText(nmo_unit, 335, 353);
      const date = new Date();
      ctx_id.fillText(date.getFullYear(), 330, 430);
      ctx_id.fillText(FormDetails.phone, 185, 545);
      ctx_id.fillText(FormDetails.email, 185, 580);
      ctx_id.fillText(FormDetails.blood_group, 185, 615);
      ctx_id.font = "20px serif";
      const state = `${FormDetails.address.city} ${","}${
        FormDetails.address.state
      } ${","}${FormDetails.address.pincode}`;
      ctx_id.fillText(state, 185, 655);
      // ctx_id.fillText(address2, 180, 675)

      setTempIdCards(can_id.current.toDataURL("image/jpeg"));
    }

    // if (upload) {
    //     // can.current.toBlob(function(blob){
    //     //     setTempCert(blob);
    //     // }, "image/jpeg")
    // }
  }
  function generateId(mem_no, doc_name, upload) {
    // const can_id = canvas3;
    // const ctx_id = can_id.current.getContext("2d");
    // const img_id = image3.current;
    // ctx_id.drawImage(img_id, 0, 0)
    // ctx_id.font = "32px serif";
    // ctx_id.fillText(mem_no, 550, 267);
    // // const dd = new Date();
    // // ctx.fillText(dd.getDate() + '/' + (dd.getMonth()+1) + '/' + dd.getFullYear(), 1050, 250);
    // ctx_id.font = "40px serif";
    // ctx_id.fillStyle = "#2D308F";
    // ctx_id.fillText(doc_name,485,340)
    // // const element = document.createElement("a");

    // setTempIdCard(can_id.current.toDataURL("image/jpeg"))

    if (upload) {
      // can.current.toBlob(function(blob){
      //     setTempCert(blob);
      // }, "image/jpeg")
    }
  }
  // 21 oct jyoti
  // we want to disable or unbale isVerified button
  // var showVerifiedButton=0
  // if (FormDetails.payment.success === FormDetails.isVerified){
  //     showVerifiedButton = 1
  // }handleEdit
  // console.log(showVerifiedButton)
  // 21 oct comment this and make other
  var s = [];
  const handleEdit = async () => {
    const result_prant = await axios.post(`${ApiURL}/api/get_prant_list`, {
      state_name: FormDetails.nmo_state,
    });
    setProgress2(0);
    setProgress1(0);

    setNmoPrant(result_prant.data.prant_name);
    if (Editable) {
      setEditable(false);
    } else {
      //  console.log(FData,"fdata........")

      const result = await axios.get(`${ApiURL}/api/get_states`);
      // console.log(result.data,"api result..")
      result.data.forEach((element) => {
        // console.log(element.state_name,"ellee")
        s.push(element.state_name);
        // }
      });
      setNmoLists(s);
      if (FData.qual.length === 0) {
        const result = await axios.get(`${ApiURL}/constants/all`);
        dispatch({ type: "SET_STATES", payload: result.data.state });
        dispatch({ type: "SET_NMOSTATES", payload: result.data.nmostate });
        dispatch({ type: "SET_QUAL", payload: result.data.qual });
      }
      // getCollage(FormDetails.nmo_state)
      collegeChanged(FormDetails.college);
      setTempDetails(FormDetails);
      // setCName(FormDetails.college)

      setEditable(true);
      FData.states.forEach((item) => {
        if (item.state === FormDetails.address.state) {
          setTempCList(item.districts);
        }
      });
    }
  };

  const handleUpdate = async () => {
    const result = await axios.post(`${ApiURL}/api/update_app`, TempDetails);
    if (result.status === 200) {
      const all_update = JSON.parse(result.config.data);
      const NumberRef = Number(all_update.ref_membership_no);
      if (all_update.email === "") {
        setEmailError("Email Id is Required");
        setnameE("");
        alert("Email Id is Required");
      } else if (
        !all_update.email.includes("@") ||
        !all_update.email.includes(all_update.email.toLowerCase())
      ) {
        setEmailError("Inavlid Email");
        alert("Inavlid Email");
        setnameE("");
      } else if (all_update.phone == "") {
        setphoneE("Number is Required");
        alert("Number is Required");
        setEmailError("");
        setnameE("");
      } else if (all_update.phone.length < 10) {
        setEmailError("");
        setphoneE("invalid Number");
        alert("invalid Number");
        setnameE("");
      } else if (all_update.profile_image === "") {
        setEmailError("");
        setProfileE("profile image is Required");
        alert("profile image is Required");
        setnameE("");
      } else if (all_update.signature_image === "") {
        setEmailError("");
        setsignatureE("sigature image is Required");
        alert("sigature image is Required");
        setnameE("");
      } else if (all_update.cert_image === "") {
        setEmailError("");
        setmedError("Medical Licence  is Required");
        alert("Medical Licence  is Required");
        setnameE("");
      } else if (all_update.ref_membership_no == "") {
        setEmailError("");
        setRefMemN("Ref Membership Number is Required");
        alert("Ref Membership Number is Required");
        setnameE("");
      } else if (all_update.ref_person_phone == "") {
        setsecphoneE("Number is Required");
        alert("Number is Required");
        setEmailError("");
        setnameE("");
      } else if (typeof Number(all_update.regno) !== "number") {
        setRegE("Reg Number should be Number");
        alert("Reg Number should be Number");
      } else if (all_update.phone.length < 9) {
        setEmailError("");
        setsecphoneE("invalid Number");
        alert("invalid Number");
        setnameE("");
      } else if (typeof NumberRef !== "number") {
        setRefMemN("Ref Membership Number should be Number");
        alert("Ref Membership Number should be Number");
        setEmailError("");
        setnameE("");
      } else if (all_update.ref_person === "") {
        setRefnameE("Name is Required");
        alert("Name is Required");
        setEmailError("");
      } else if (all_update.state_sec_email === "") {
        alert("Secretary Email Id is Required");
        setsecEmailError("Secretary Email Id is Required");
        setEmailError("");
        setnameE("");
      } else if (
        !all_update.state_sec_email.includes("@") ||
        !all_update.state_sec_email.includes(
          all_update.state_sec_email.toLowerCase()
        )
      ) {
        setsecEmailError("Inavlid Email");
        alert("Inavlid Email");
        setEmailError("");
        setnameE("");
      } else {
        setTp(Tp + 1);
        setTp1(Tp1 + 1);
        dispatch({ type: "SELECTED_APPLICATION", payload: TempDetails });
        setEditable(false);
      }
    }
  };
  const handleChange = (e) => {
    setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });
  };
  const handleAddChange = (e) => {
    if (e.target.name === "state") {
      FData.states.map((item) => {
        if (item.state === e.target.value) {
          setTempCList(item.districts);
        }
        return true;
      });
    }
    setTempDetails({
      ...TempDetails,
      address: { ...TempDetails.address, [e.target.name]: e.target.value },
    });
  };
  const handelNmoState = async (e) => {
    // console.log(TempDetails.nmo_state, "nmokkkkkkkk")
    setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });
    const result = await axios.post(`${ApiURL}/api/get_prant`, {
      state: e.target.value,
    });
    console.log(result.data.prant_name, "prant ll...");
    setNmoPrant(result.data.prant_name);
  };



  const handelNmoPrant = async (e) => {
    setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });
    console.log(e.target.name, "nn");
    console.log(e.target.value, "vvv");
  };
const handleFileChange = async (e) => {
  try {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split(".").pop().toLowerCase();
    let filename = "";
    let group = "";

    // Validate file type and determine filename
    if (e.target.name === "profile_image") {
      if (!["jpg", "jpeg", "bmp", "png"].includes(ext)) {
        alert("Only JPG, BMP, PNG files allowed");
        return;
      }

      group = FormDetails.profile_image.split("/");
      filename = group.pop().split(".")[0];
      setsign(true);
    }

    const key = `applications/${FormDetails.appId}/${filename}.${ext}`;

    // 1️⃣ Get signed URL from backend
    const res = await axios.get(
      `${ApiURL}/api/upload/signed-url?key=${encodeURIComponent(
        key
      )}&contentType=${encodeURIComponent(file.type)}`
    );
    const { url } = res.data;
    console.log("Signed URL generated: ", url);

    // 2️⃣ Upload with XHR and progress
    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", file.type);
      xhr.setRequestHeader("Cache-Control", "no-cache"); 
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setProgress1(percent);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) resolve(xhr.response);
        else reject(new Error(`Upload failed with status ${xhr.status}`));
      };

      xhr.onerror = () => reject(new Error("Upload failed due to network error"));
      xhr.send(file);
    });

    // 3️⃣ Update temporary details with R2 public URL
    setTempDetails({
      ...TempDetails,
      [e.target.name]: `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${key}`,
    });

    console.log("File uploaded successfully:", key);
  } catch (err) {
    console.error("File upload error:", err);
  }
};

const handleIdChange = async (e) => {
  try {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split(".").pop().toLowerCase();
    let filename = "";
    let group = "";

    // Validate file type and determine filename
    if (e.target.name === "cert_image") {
      if (!["jpg", "jpeg", "bmp", "png", "pdf"].includes(ext)) {
        alert("Only JPG, BMP, PNG & PDF files allowed");
        return;
      }

      group = FormDetails.cert_image.split("/");
      filename = group.pop().split(".")[0];
      setsign1(true);
    }

    const key = `applications/${FormDetails.appId}/${filename}.${ext}`;

    // 1️⃣ Get signed URL from backend
    const res = await axios.get(
      `${ApiURL}/api/upload/signed-url?key=${encodeURIComponent(
        key
      )}&contentType=${encodeURIComponent(file.type)}`
    );
    const { url } = res.data;
    console.log("Signed URL generated: ", url);

    // 2️⃣ Upload file with XHR and progress
    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", file.type);
      xhr.setRequestHeader("Cache-Control", "no-cache"); 

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setProgress1(percent);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) resolve(xhr.response);
        else reject(new Error(`Upload failed with status ${xhr.status}`));
      };

      xhr.onerror = () => reject(new Error("Upload failed due to network error"));
      xhr.send(file);
    });

    // 3️⃣ Update temporary details with R2 public URL
    setTempDetails({
      ...TempDetails,
      [e.target.name]: `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${key}`,
    });

    console.log("File uploaded successfully:", key);
  } catch (err) {
    console.error("File upload error:", err);
  }
};

const uplodeSign = async (e) => {
  try {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split(".").pop().toLowerCase();
    if (!["jpg", "jpeg", "bmp", "png"].includes(ext)) {
      alert("Only JPG, BMP, PNG files allowed");
      return;
    }

    const key = `applications/${FormDetails.appId}/signature_image.${ext}`;

    // 1️⃣ Get signed URL from backend
    const res = await axios.get(
      `${ApiURL}/api/upload/signed-url?key=${encodeURIComponent(
        key
      )}&contentType=${encodeURIComponent(file.type)}`
    );
    const { url } = res.data;
    console.log("Signed URL generated:", url);

    // 2️⃣ Upload with XHR and track progress
    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", file.type);
xhr.setRequestHeader("Cache-Control", "no-cache"); 
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          setProgress2(Math.round((event.loaded / event.total) * 100));
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) resolve();
        else reject(new Error(`Upload failed with status ${xhr.status}`));
      };
      xhr.onerror = () => reject(new Error("Network error during upload"));

      xhr.send(file);
    });

    // 3️⃣ Update form state with public R2 URL
    setTempDetails({
      ...TempDetails,
      [e.target.name]: `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${key}`,
    });

    console.log("File uploaded successfully:", key);
    setProgress2(0);
  } catch (err) {
    console.error("Upload error (signature):", err);
  }
};


    const getUpdateUrl = (url)=>{

    const oldDomain = "nmobucket.s3.ap-south-1.amazonaws.com";
  const newDomain = "pub-5e98b3129b274a77aa3ee9286a182644.r2.dev";

  return url.replace(oldDomain, newDomain);

  }

  return (
    <>
      {isLoadingApplication ? (
        <div style={{ display: "flex", justifyContent: "center", padding: "50px" }}>
          <CircularProgress />
        </div>
      ) : (
        FormDetails._id !== undefined && (
        <div style={{ textAlign: "center", padding: "0 0 50px 0" }}>
          <h1>Application Form</h1>
          {/* 04 December Ranjana Chaudhary made date of birth,profile and signature img editable  */}

          <div className="applicationContainer">
            <div className="applicationFields">
              <table className="applicationTable">
                <tr>
                  <td>
                    <Button
                      variant="contained"
                      color={Editable ? "secondary" : "primary"}
                      onClick={handleEdit}
                    >
                      {Editable ? "Cancel" : "Edit"}
                    </Button>
                  </td>
                  <td>
                    {Editable && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleUpdate}
                      >
                        Update
                      </Button>
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Profile Image</td>
                  {Editable ? (
                    <>
                      <img
                        // src={FormDetails.profile_image}
                        src = {getUpdateUrl(FormDetails.profile_image)}
                        className="img"
                        style={{ position: "relative", top: "8px" }}
                        width={125}
                        alt="Profile"
                      />
                      <input
                        name="profile_image"
                        type="file"
                        onChange={handleFileChange}
                      />
                      <LinearProgress variant="determinate" value={Progress1} />
                      <p className="update">{profileE}</p>
                    </>
                  ) : (
                    <>
                      <td style={{ height: "149px" }}>
                        <img
                          // src={FormDetails.profile_image}
                        src = {getUpdateUrl(FormDetails.profile_image)}

                          className="img"
                          width={125}
                          alt="Profile"
                        />
                        <a
                          style={{
                            position: "relative",
                            right: "95px",
                            top: "8px",
                          }}
                          // href={FormDetails.profile_image}
                        href = {getUpdateUrl(FormDetails.profile_image)}
                          download
                          target="_blank"
                          rel="noreferrer"
                        >
                          Click Here to Download
                        </a>
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  <td colSpan="2">
                    <b>
                      <u>Doctor Details</u>
                    </b>
                  </td>
                </tr>
                <tr>
                  <td>Doctor Name</td>
                  <td>{FormDetails.name}</td>
                </tr>
                <tr>
                  <td>Date of Birth (dd/mm/yyyy)</td>

                  {Editable ? (
                    <input
                      name="dob"
                      value={TempDetails.dob}
                      onChange={handleChange}
                      type="date"
                      format="dd/MM/yyyy"
                    />
                  ) : (
                    <td>
                      {new Date(FormDetails.dob).getDate() +
                        "/" +
                        (new Date(FormDetails.dob).getMonth() + 1) +
                        "/" +
                        new Date(FormDetails.dob).getFullYear()}
                    </td>
                  )}
                </tr>

                <tr>
                  <td>Gender</td>
                  <td>{FormDetails.gender.toUpperCase()}</td>
                </tr>
                <tr>
                  <td>Blood Group</td>
                  <td>{FormDetails.blood_group.toUpperCase()}</td>
                </tr>
                <tr>
                  <td>Phone Number</td>
                  {Editable ? (
                    <>
                      <input
                        name="phone"
                        value={TempDetails.phone}
                        onChange={handleChange}
                        type="number"
                      />
                      <p className="update">{phoneE}</p>
                    </>
                  ) : (
                    <td>{FormDetails.phone}</td>
                  )}
                </tr>
                <tr>
                  <td>Email Address</td>
                  {Editable ? (
                    <>
                      <input
                        name="email"
                        value={TempDetails.email}
                        onChange={handleChange}
                        type="email"
                      />
                      <p className="update">{emailError}</p>
                    </>
                  ) : (
                    <td>{FormDetails.email}</td>
                  )}
                </tr>
                <tr>
                  <td>Signature Image</td>
                  {Editable ? (
                    <>
                      <img
                        // src={FormDetails.signature_image}
                        src={getUpdateUrl(FormDetails.signature_image)}
                        className="img"
                        style={{ position: "relative", top: "8px" }}
                        width={125}
                        alt="Signature"
                      />
                      <input
                        name="signature_image"
                        type="file"
                        onChange={uplodeSign}
                      />
                      <LinearProgress variant="determinate" value={Progress2} />
                      <p className="update">{profileE}</p>
                    </>
                  ) : (
                    <>
                      <td style={{ height: "149px" }}>
                        <img
                          // src={FormDetails.signature_image}
                        src={getUpdateUrl(FormDetails.signature_image)}

                          className="img"
                          width={125}
                          alt="Signature"
                        />
                        <a
                          style={{
                            position: "relative",
                            right: "95px",
                            top: "8px",
                          }}
                          // href={FormDetails.signature_image}
                        href={getUpdateUrl(FormDetails.signature_image)}
                          download
                          target="_blank"
                          rel="noreferrer"
                        >
                          Click Here to Download
                        </a>
                      </td>
                    </>
                  )}
                </tr>
                <tr>
                  <td colSpan="2">
                    <b>
                      <u>Educational Details</u>
                    </b>
                  </td>
                </tr>
                <tr>
                  <td>Applicant is a</td>
                  <td>{FormDetails.docstatus.toUpperCase()}</td>
                </tr>
                <tr>
                  <td>Highest Medical Degree</td>
                  {Editable ? (
                    <select
                      name="qualifications"
                      value={TempDetails.qualifications}
                      onChange={handleChange}
                    >
                      {FData.qual.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <td>{FormDetails.qualifications}</td>
                  )}
                  {/* 22 oct jyoti added edit button and change we can edit the qualification ----- */}
                </tr>
                <tr>
                  <td>College</td>
                  {Editable ? (
                    <div className="ctrl">
                      <select
                        name="state"
                        value={SName}
                        onChange={stateChanged}
                      >
                        {stateList.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      {isTrue ? (
                        <select
                          name="college"
                          defaultValue={CName}
                          value={CName}
                          onChange={(e) => collegeChanged(e.target.value)}
                        >
                          {/* {console.log(collagelist,'colllllllege')} */}
                          {collagelist.length > 0 ? (
                            collagelist.map((item, index) => (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            ))
                          ) : (
                            <option value={CName}>{CName}</option>
                          )}
                        </select>
                      ) : (
                        <input
                          name="college"
                          value={
                            TempDetails.college == "other"
                              ? ""
                              : TempDetails.college
                          }
                          placeholder="Enter Your Collage Name"
                          onChange={handleChange}
                        />
                      )}
                    </div>
                  ) : (
                    <td>{FormDetails.college}</td>
                  )}
                </tr>
                <tr>
                  <td>Medical License / College Reg No</td>
                  {Editable ? (
                    <>
                      <input
                        name="regno"
                        value={TempDetails.regno}
                        onChange={handleChange}
                      />
                      <p className="update">{RegE}</p>
                    </>
                  ) : (
                    <td>{FormDetails.regno}</td>
                  )}
                  {/* 22 oct jyoti edit  */}

                  {/* <td>{FormDetails.regno}</td> */}
                </tr>
                <tr>
                  <td>Medical License / College ID</td>
                  {Editable ? (
                    <td>
                      <input
                        name="cert_image"
                        type="file"
                        onChange={handleIdChange}
                      />
                      <p className="update">{medError}</p>
                    </td>
                  ) : (
                    // <td>
                    // <button className="btn btn-primary" onClick={() => {FormDetails.cert_image}}>View</button>
                    // </td>

                    <td>
                      <a
                        // href={FormDetails.cert_image}
                        href={getUpdateUrl(FormDetails.cert_image)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Click Here to View
                      </a>
                    </td>
                  )}
                  {/* <td><a href={FormDetails.cert_image} target="_blank" rel="noreferrer">Click Here to View</a></td> */}
                </tr>

                <tr>
                  <td>
                    <b>
                      <u>Correspondence Address</u>
                    </b>
                  </td>
                  {Editable ? (
                    <td>
                      <input
                        name="line1"
                        value={TempDetails.address.line1}
                        onChange={handleAddChange}
                      />
                      <input
                        name="line2"
                        value={TempDetails.address.line2}
                        onChange={handleAddChange}
                      />
                      <select
                        name="state"
                        value={TempDetails.address.state}
                        onChange={handleAddChange}
                      >
                        {FData.states.map((item, index) => (
                          <option key={index} value={item.state}>
                            {item.state}
                          </option>
                        ))}
                      </select>
                      <select
                        name="city"
                        value={TempDetails.address.city}
                        onChange={handleAddChange}
                      >
                        {TempCList.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      <input
                        name="pincode"
                        value={TempDetails.address.pincode}
                        onChange={handleAddChange}
                      />
                    </td>
                  ) : (
                    <td>
                      {FormDetails.address.line1}
                      <br />
                      {FormDetails.address.line2}
                      <br />
                      {FormDetails.address.city}, {FormDetails.address.state}
                      <br />
                      {FormDetails.address.pincode}
                    </td>
                  )}
                  {/* <td>
                                    {FormDetails.address.line1}<br/>
                                    {FormDetails.address.line2}<br/>
                                    {FormDetails.address.city}, {FormDetails.address.state}<br/>
                                    {FormDetails.address.pincode}
                                </td> */}
                </tr>
                <tr>
                  <td colSpan="2">
                    <b>
                      <u>Association with NMO</u>
                    </b>
                  </td>
                </tr>
                <tr>
                  <td>NMO State</td>
                  {Editable ? (
                    <select
                      name="nmo_state"
                      value={TempDetails.nmo_state}
                      onChange={handelNmoState}
                    >
                      {nmoLists.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <td>{FormDetails.nmo_state}</td>
                  )}
                  {/* <td>{FormDetails.nmo_state}</td> */}
                </tr>
                {/* <tr>
                                <td>NMO Prant</td>
                                {
                                    Editable ? 
                                    <select name="prant" value={TempDetails.prant} onChange={handelNmoPrant}>
                                        {
                                            nmoPrant.map((item, index) => (
                                                <option key={index} value={item}>{item}</option>
                                            ))
                                        }
                                    </select>:
                                    <td>{FormDetails.prant}</td>
                                }
                              
                            </tr> */}
                <tr>
                  <td>NMO unit</td>
                  {Editable ? (
                    <td>
                      <input
                        name="nmo_unit"
                        value={TempDetails.nmo_unit}
                        onChange={handleChange}
                        type="text"
                      />
                      {/* <p className="update">{profileE}</p> */}
                    </td>
                  ) : (
                    <td>{FormDetails.nmo_unit}</td>
                  )}
                  {/* <td>{FormDetails.nmo_unit}</td> */}
                </tr>
                <tr>
                  <td>NMO State Secretary Email</td>
                  {Editable ? (
                    <td>
                      <input
                        name="state_sec_email"
                        value={TempDetails.state_sec_email}
                        onChange={handleChange}
                        type="text"
                      />
                      <p className="update">{secEmailError}</p>
                    </td>
                  ) : (
                    <td>{FormDetails.state_sec_email}</td>
                  )}
                  {/* <td>{FormDetails.state_sec_email}</td> */}
                </tr>
                <tr>
                  <td>Referrer/Contact Person Name</td>
                  {Editable ? (
                    <td>
                      <input
                        name="ref_person"
                        value={TempDetails.ref_person}
                        onChange={handleChange}
                        type="text"
                      />
                      <p className="update">{RefnameE}</p>
                    </td>
                  ) : (
                    <td>{FormDetails.ref_person}</td>
                  )}
                  {/* <td>{FormDetails.ref_person}</td> */}
                </tr>
                <tr>
                  <td>Referrer/Contact Person Phone Number</td>
                  {Editable ? (
                    <td>
                      <input
                        name="ref_person_phone"
                        value={TempDetails.ref_person_phone}
                        onChange={handleChange}
                        type="text"
                      />
                      <p className="update">{secphoneE}</p>
                    </td>
                  ) : (
                    <td>{FormDetails.ref_person_phone}</td>
                  )}
                  {/* <td>{FormDetails.ref_person_phone}</td> */}
                </tr>
                <tr>
                  <td>Referrer/Contact Person NMO Membership Number</td>
                  {Editable ? (
                    <td>
                      <input
                        name="ref_membership_no"
                        value={TempDetails.ref_membership_no}
                        onChange={handleChange}
                        type="text"
                      />
                      <p className="update">{RefMemN}</p>
                    </td>
                  ) : (
                    <td>{FormDetails.ref_membership_no}</td>
                  )}
                  {/* <td>{FormDetails.ref_membership_no}</td> */}
                </tr>
                <tr>
                  <td colSpan="2">
                    <b>
                      <u>Application Details</u>
                    </b>
                  </td>
                </tr>
                <tr>
                  <td>Applied As</td>
                  <td>{FormDetails.appType.toUpperCase()}</td>
                </tr>
                <tr>
                  <td>Mode of Application</td>
                  <td>
                    {FormDetails.payment.mode === "Online"
                      ? "Online"
                      : "Offline"}
                  </td>
                </tr>
                <tr>
                  <td>Transaction ID / Transaction Details</td>
                  <td>{FormDetails.payment.transactionId}</td>
                </tr>
                <tr>
                  <td>Membership Fee</td>
                  <td>₹ {FormDetails.payment.amount || FormDetails.appFee}</td>
                </tr>
                <tr>
                  <td>Payment Status</td>
                  <td>
                    {FormDetails.payment.success ? (
                      "Completed"
                    ) : FormDetails.payment.mode === "Online" ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setIsOpen3(true)}
                        disabled={Editable}
                      >
                        Confirm Payment
                      </Button>
                    ) : (
                      "Offline"
                    )}
                  </td>
                  {/* <td>{!FormDetails.payment.success && FormDetails.payment.mode === 'Online' ?<Button variant="contained" color="secondary" onClick={() => setIsOpen5(true)} disabled={Editable || FormDetails.payment.success}>delete</Button>:""}</td> */}
                </tr>
                {/* <tr> */}
                {/* <td>{!FormDetails.payment.success && FormDetails.payment.mode === 'Online' ?<Button variant="contained" color="secondary" onClick={() => setIsOpen5(true)} disabled={Editable || FormDetails.payment.success}>delete</Button>:"ppp"}</td> */}
                {/* </tr> */}

                {/* <tr>
                                <td>Delete From</td>
                                <td>{FormDetails.payment.success ? "payment success" : ((FormDetails.payment.mode === 'Online')?<Button variant="contained" color="secondary" onClick={() => setIsOpen5(true)} disabled={Editable}>delete</Button>: "Offline")}</td>
                            </tr> */}

                {/* disabled={FormDetails.payment.success}?<tr>
                                <td>Delete From</td>
                                <td>{FormDetails.payment.success ? "payment success" : ((FormDetails.payment.mode === 'Online')?<Button variant="contained" color="secondary" onClick={() => setIsOpen5(true)} disabled={Editable}>delete</Button>: "Offline")}</td>
                            </tr> */}

                <tr>
                  <td>Application Status</td>
                  <td>
                    {FormDetails.appApprove ? "Approved" : "Not Approved"}
                  </td>

                  {/* // 21 oct jyoti changed Application status */}
                  {/* <td>{FormDetails.isVerified ? "Verified" : ((FormDetails.appApprove)? "Approved" :"Not Approved")}</td> */}
                </tr>
                {FormDetails.appApprove && (
                  <tr>
                    <td>Member Profile</td>
                    <td>
                      <a
                        href={
                          FormDetails.appType === "student"
                            ? `/admin/student/${FormDetails._id}`
                            : `/admin/members/${FormDetails._id}`
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        Open Member View
                      </a>
                    </td>
                  </tr>
                )}
                <tr>
                  <td>Verification</td>
                  {/* 21 oct jyoti 
                            added verified button */}
                  <td>
                    {!FormDetails.payment.success ? (
                      "Not Verified"
                    ) : FormDetails.isVerified === false &&
                      FormDetails.payment.success === true ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setIsOpen6(true)}
                        disabled={Editable}
                      >
                        Verify
                      </Button>
                    ) : (
                      "Verified"
                    )}
                  </td>
                </tr>
                {FormDetails.appApproved ? (
                  <tr></tr>
                ) : (
                  <tr>
                    <td>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleApprove}
                        disabled={
                          Editable ||
                          !FormDetails.isVerified ||
                          loginRes === "Employee"
                        }
                      >
                        Approve
                      </Button>
                    </td>
                    <td>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleReject}
                        disabled={
                          Editable ||
                          !FormDetails.isVerified ||
                          loginRes === "Employee"
                        }
                      >
                        Reject
                      </Button>
                    </td>

                    {/* 20 oct jyoti change Approve and reject button */}
                  </tr>
                )}
              </table>
              <div style={{ marginTop: "1rem" }}>
                {!FormDetails.payment.success &&
                FormDetails.payment.mode === "Online" ? (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setIsOpen5(true)}
                    disabled={Editable || FormDetails.payment.success}
                  >
                    Delete Application
                  </Button>
                ) : (
                  ""
                )}

                {FormDetails.payment.success &&
                FormDetails.payment.mode === "Online" ? (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setIsOpen7(true)}
                    // disabled={Editable || FormDetails.payment.success}
                  >
                    Fee Refunded
                  </Button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div>
            <canvas ref={canvas} width={1280} height={973} className="hidden" />
            <img ref={image} src={cert} className="hidden" alt="testbed" />
            <canvas
              ref={canvas4}
              width={1280}
              height={940}
              className="hidden"
            />
            <img
              ref={image4}
              src={studentCert}
              className="hidden"
              alt="testbed"
            />
          </div>

          <div>
            <canvas
              ref={canvas1}
              width={1240}
              height={1700}
              className="hidden"
            />
            <img ref={image1} src={welen} alt="testbed" className="hidden" />
            <canvas
              ref={canvas0}
              width={1240}
              height={1700}
              className="hidden"
            />
            <img ref={image0} src={stwelen} alt="testbed" className="hidden" />
          </div>
          <div>
            <canvas
              ref={canvas2}
              width={1240}
              height={1700}
              className="hidden"
            />
            <img ref={image2} src={welhi} alt="testbed" className="hidden" />
            <canvas
              ref={canvas7}
              width={2481}
              height={3509}
              className="hidden"
            />
            <img ref={image7} src={stwelhi} alt="testbed" className="hidden" />
          </div>
          <div>
            <canvas ref={canvas3} width={635} height={931} className="hidden" />
            <img ref={image3} src={idcard} alt="testbed" className="hidden" />
            <canvas ref={canvas5} width={620} height={890} className="hidden" />
            <img
              ref={image5}
              src={studentId}
              alt="testbed"
              className="hidden"
            />
            {/* <img ref={image4} src={FormDetails.profile_image}  alt="testbed" className="hidden"/> */}
          </div>
        </div>
      ))}
      <Dialog fullScreen open={Open} onClose={handleClose}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 30px",
          }}
        >
          <h3>Finalize Application Approval</h3>
          <Button
            variant="contained"
            onClick={handleClose}
            disabled={isSubmitting}
            color="secondary"
          >
            Close
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            padding: "10px, 30px",
          }}
        >
          {/* {console.log('adminnnnn')} */}
          {FormDetails.appType !== "student" ? (
            <img src={TempImg} alt="temp" width={600} height={480} />
          ) : (
            <img src={TempImg2} alt="temp" width={600} height={480} />
          )}
          {FormDetails.appType !== "student" ? (
            <img src={TempIdCard} alt="temp" width={410} height={600} />
          ) : (
            <img src={TempIdCards} alt="temp" width={410} height={600} />
          )}
          {FormDetails.appType !== "student" ? (
            <div>
              <h4>Update Membership Certificate (optional)</h4>
              <TextField
                value={TempName}
                label="Update Doctor Name"
                onChange={handleTempName}
              />
              <TextField
                value={TempQul}
                label="Update Doctor Qualification"
                onChange={handleTempQul}
              />
              {/* <Button variant="contained" color="primary" disabled={isSubmitting} onClick={() => generateCert(String(activeMembershipNo() || ""), TempName, TempQul,FormDetails.college, FormDetails.nmo_unit, FormDetails.email, FormDetails.blood_group, `${FormDetails.address.line1} , ${FormDetails.address.line2}`, FormDetails.phone,`${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`,  true)}>Update</Button> */}
              <Button
                variant="contained"
                color="primary"
                disabled={isSubmitting}
                onClick={() =>
                  generateCert(
                    String(activeMembershipNo() || ""),
                    TempName,
                    TempQul,
                    FormDetails.college,
                    FormDetails.nmo_unit,
                    FormDetails.email,
                    FormDetails.blood_group,
                    `${FormDetails.address.line1} , ${FormDetails.address.line2}`,
                    FormDetails.phone
                  )
                }
              >
                Update
              </Button>
            </div>
          ) : (
            <div>
              <h4>Update Membership Certificate (optional)</h4>
              <TextField
                value={TempName}
                label="Update Student Name"
                onChange={handleTempName}
              />
              <TextField
                value={TempQul}
                label="Update Student Qualification"
                onChange={handleTempQul}
              />
              <TextField
                value={TempCour}
                label="Update Student College"
                onChange={handleTempCour}
              />
              <Button
                variant="contained"
                color="primary"
                disabled={isSubmitting}
                onClick={() =>
                  generateCert(
                    String(activeMembershipNo() || ""),
                    TempName,
                    TempQul,
                    TempCour,
                    FormDetails.nmo_unit,
                    FormDetails.email,
                    FormDetails.blood_group,
                    `${FormDetails.address.line1} , ${FormDetails.address.line2}`,
                    FormDetails.phone,
                    `${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`,
                    true
                  )
                }
              >
                Update
              </Button>
            </div>
          )}
        </div>
        {/* {console.log(i)} */}
        {uploadsComplete ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px, 30px",
            }}
          >
            <Button
              variant="contained"
              disabled={isUploading || isApproving}
              color="primary"
              onClick={() => {
                if (!validateApprovalDocuments()) {
                  alert(
                    "Documents are not ready yet. Please upload documents again."
                  );
                  setUploadsComplete(false);
                  return;
                }
                setIsOpen1(true);
              }}
            >
              Click Here to Approve Application
            </Button>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px, 30px",
              gap: "12px",
            }}
          >
            <Button
              variant="contained"
              disabled={isUploading}
              color="primary"
              onClick={handleSubApp}
            >
              {isUploading ? "Uploading Documents..." : "Upload Documents"}
            </Button>
            {isUploading && (
              <>
                <CircularProgress size={32} />
                {Progress1 > 0 && (
                  <LinearProgress
                    variant="determinate"
                    value={Progress1}
                    style={{ width: "60%", marginTop: 8 }}
                  />
                )}
              </>
            )}
          </div>
        )}
      </Dialog>
      <Dialog fullScreen open={Open1} onClose={handleClose}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 30px",
          }}
        >
          <h3>Finalize Application Rejection</h3>
          <Button variant="contained" onClick={handleClose} color="secondary">
            Close
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            padding: "10px, 30px",
          }}
        >
          <div style={{ maxWidth: "500px" }}>
            <h4>Email Sample</h4>
            <p>
              {`This is regarding your membership application at National Medicos Organization.`}
              <br />
              {`Please provide following information in the given format:`}
              <br />
              <br />
              {TempReason}
              <br />
              <br />
              {`Vande Mataram!`}
              <br />
              {`Bharat Mata ki Jai`}
            </p>
          </div>
          <div>
            <h4>Provide Reason for Rejection</h4>
            <textarea
              minRows={4}
              value={TempReason}
              placeholder="Type here"
              onChange={handleTempReason}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "10px, 30px",
          }}
        >
          <Button
            variant="contained"
            disabled={TempReason.length === 0}
            color="primary"
            onClick={handleFinalReject}
          >
            Click Here to Reject Application
          </Button>
        </div>
      </Dialog>
      <Dialog open={IsOpen1}>
        <DialogTitle>{"Approve Application?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {isApproving
              ? "Approving application. This may take up to a minute — please do not close this window."
              : "Are you sure, you want to approve application?"}
          </DialogContentText>
          {isApproving && (
            <div style={{ display: "flex", justifyContent: "center", marginTop: 16 }}>
              <CircularProgress />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleFinalApproval}
            disabled={isApproving}
            color="primary"
          >
            Yes
          </Button>
          <Button onClick={handleNoApp} disabled={isApproving} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={IsOpen6}>
        <DialogTitle>{"Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure, you want to verify application?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleVarified} color="primary">
            Yes
          </Button>
          <Button onClick={handleNoApp} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={IsOpen2}>
        <DialogTitle>{"Reject Application?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure, you want to reject application?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRejApp} color="primary">
            Yes
          </Button>
          <Button onClick={handleNoApp} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={IsOpen3}>
        <DialogTitle>{"Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure, you want to confirm payment?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmPayment} color="primary">
            Yes
          </Button>
          <Button onClick={handleNoApp} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={IsOpen5}>
        <DialogTitle>{"Delete Application"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure, you want to delete this?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} color="primary">
            Yes
          </Button>
          <Button onClick={handleNoApp} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={IsOpen7}>
        <DialogTitle>{"Refund Completed"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure, you want to delete this application?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFeeRefunded} color="primary">
            Yes
          </Button>
          <Button onClick={handleNoApp} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={IsOpen4}>
        <DialogTitle>{"Check Payment Status"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Payment for this application has some errors, please check with
            payment service provider.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen4(false)} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AdminApplicationsView;
